import {SyncState} from "@/domain/type/synchro.type.ts";
import {RequestEntityState, RequestEntityStatus, type SourceDetails} from "@/domain/type/synchro.api.type.ts";
import type {RouteLocationAsRelative} from "vue-router";
import {type CardData, EntityAction} from "@/domain/type/entity.type.ts";
import type {Source} from "@/domain/type/source.type.ts";

export abstract class AbstractEntity {
  uuid: string
  state: SyncState
  left: any
  right: any
  leftLink: string = '';
  rightLink: string = '';
  actions: EntityAction[] = [];
  cardIcon: string = '';

  public constructor(uuid: string, leftFromApi: SourceDetails[], rightFromApi: SourceDetails[][], state: RequestEntityState, status: RequestEntityStatus) {
    this.uuid = uuid;
    this.state = this.hydrateState(state, status)
    this.actions = this.getActions();
  }

  protected filterLink(link: string): string {
    if(import.meta.env.VITE_AMMON_BASE_URL_OLD === import.meta.env.VITE_AMMON_BASE_URL) {
      return link;
    }
    return link.replace(import.meta.env.VITE_AMMON_BASE_URL_OLD + '/AMMON', import.meta.env.VITE_AMMON_BASE_URL + '/BO/s')
  }

  public abstract getCreateActionText(srcRight: Source): string

  public hasAction(): boolean {
    return 0 < this.actions.length
  }

  public abstract getActions(): EntityAction[];

  public abstract match(filter: string): boolean;

  public abstract fusionLink(): RouteLocationAsRelative;

  public abstract getLeftCardData(): CardData[];

  public abstract getRightCardData(): CardData[];

  protected abstract hydrateDetails(sourceDetails: SourceDetails[]): any;

  private hydrateState(state: RequestEntityState, status: RequestEntityStatus) {
    switch (state) {
      case RequestEntityState.MATCH:
        if (status === RequestEntityStatus.SYNCHRONIZED) {
          return SyncState.OK
        }
        return SyncState.DIFF
      case RequestEntityState.NOT_ANY:
        return SyncState.MISSING
      case RequestEntityState.TOO_MANY:
        return SyncState.TOO_MANY
      case RequestEntityState.MATCH_NOT_SIMILAR:
        return SyncState.OTHER_OWNER
      default:
        return SyncState.DISABLED
    }
  }
}
